import { render } from "./FAQ.vue?vue&type=template&id=02f7686c&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=ts"
export * from "./FAQ.vue?vue&type=script&lang=ts"

import "./FAQ.vue?vue&type=style&index=0&id=02f7686c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02f7686c"

export default script